<script>
  import Checkbox from 'smelte/src/components/Checkbox/Checkbox.svelte'
  import { cities } from '../../../store'
  import ComboBox from '../../ComboBox.svelte'

  export let edit = false
  export let projectProps = []
  export let data = {
    eu_is_same: true
  }

  $: isSameAddress = data.eu_is_same
  let old_isSameAddress = null
  let cities1 = []

  $: {
    fillEndUser(isSameAddress)
  }

  function fillEndUser (isSameAddress) {
    if (isSameAddress === true && old_isSameAddress != null) {
      // copy customer data to end user
      data.eu_name = ''
      data.eu_city = ''
      data.eu_country = ''
      data.eu_address = ''
    }
    if (isSameAddress === false && old_isSameAddress != null) {
      // clear end user fields
      data.eu_name = ''
      data.eu_city = ''
      data.eu_country = ''
      data.eu_address = ''
    }
    old_isSameAddress = isSameAddress
  }

  function cityHandler (event) {
    // console.log('[DEBUG] keyup', event)
    if (event.target.value === '' && cities1 != null) {
      cities1 = []
      return
    }
    const key = event.target.value.toLowerCase()
    cities1 = $cities.filter(p => p.city.toLowerCase().startsWith(key)).slice(0, 30)
      .sort((a, b) => {
        return a.city < b.city ? -1 : 1
      })
    // console.log('[DEBUG] cities filtered', cities1)
  }

  function citySelectHandler (prop, item) {
    data[prop.field] = item.city
    data[prop.countryField] = item.country
    cities1 = []
  }

  function cityOutHandler (event) {
    setTimeout(() => {
      cities1 = []
    }, 300)
  }

  function referenceChangeHandler ({detail}) {
    data.Email = detail.value
    console.log('[DEBUG] reference changed', detail)
  }
</script>

<div class="pl-3 pb-2 text-xl text-gray-400 uppercase">Project number - {data.su_erp_proj}</div>

{#each Object.keys(projectProps) as key, j}
  <div class="flex flex-wrap text-lg mb-8">

    {#if key === "end_user"}
      <div class="w-full font-light">
        {#if edit}
          <Checkbox disabled={!edit} bind:checked={data.eu_is_same} label="End User is the same as Customer" />
        {:else}
          <div>End User is the same as Customer</div>
        {/if}
      </div>
    {/if}

    {#if !(key === "end_user" && isSameAddress)}
      {#each projectProps[key] as prop, i}
        <div class="w-full xl:w-1/2 pr-4 flex items-center" style="min-height: 2.5em">

          <div class="w-1/2 h-full">
            <div class="h-full mr-2 px-3 border-b border-gray-400 flex items-center text-base">
              {prop.label}
            </div>
          </div>

          <div class="w-1/2 h-full">
            {#if edit && prop.ro !== true}
              <div class="h-full ml-2 pt-2 px-0 border-b border-gray-400 relative">
                {#if prop.check}
                  <div class="px-3">
                    <Checkbox checked={data[prop.field] === prop.check.labels[1]}
                              bind:label={data[prop.field]}
                              on:change={({detail}) => {
                                data[prop.field] = detail === true ? prop.check.labels[1] : prop.check.labels[0]
                              }}
                    />
                  </div>


                {:else if prop.city}
                  <div class="relative input-text bg-gray-200">
                    <input type="text" class="px-3 input-text bg-gray-200"
                           bind:value={data[prop.field]}
                           on:keyup={cityHandler}
                           on:blur={cityOutHandler}
                    />
                    <div class="absolute bg-white shadow w-full text-base overflow-y-auto"
                         style="max-height: 9em; top: 2.3em; z-index: 1000;">
                      {#each cities1 as c}
                        <div class="py-1 px-3 hover:bg-gray-300"
                             on:click={() => {citySelectHandler(prop, c)}}
                        >
                          {c.city + ', ' + c.country}
                        </div>
                      {/each}
                    </div>
                  </div>


                {:else if prop.field === 'Reference'}
                  <ComboBox bind:value={data[prop.field]}
                            items={prop.items}
                            bind:loading={prop.loading}
                            on:change={referenceChangeHandler} />

                {:else}
                  <input type="text" class="px-3 input-text bg-gray-200" bind:value={data[prop.field]} />
                {/if}
              </div>
            {:else}
              <div class="h-full ml-2 px-3 border-b border-gray-400 flex items-center">
                {#if prop.check != null}
                  <div>{data[prop.field]}</div>
                  <!--
                  <Checkbox disabled={true} checked={data[prop.field] === prop.check.labels[1]}
                            label={data[prop.field]} />
                  -->
                {:else if prop.currency}
                  {(data[prop.field] ? data[prop.field].toLocaleString() : '-') + ' ' + data[prop.currency]}
                {:else}
                  {data[prop.field] ? data[prop.field] : '-' }
                {/if}
              </div>
            {/if}
          </div>

        </div>
      {/each}
    {/if}
  </div>
{/each}
<style>
  .input-text {
    height: 100%;
    width: 100%;
  }
</style>
